//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Search, Group, Cell } from 'vux'
import { mapGetters } from 'vuex'
import HeaderRight from './header-right'

export default {
  name: 'contact',
  computed: {
    ...mapGetters('contact', ['userContact'])
  },
  methods: {
    detail (username) {
      this.$router.push({
        name: 'detail',
        query: {
          username
        }
      })
    }
  },
  components: {
    Group,
    Cell,
    Search
  },
  created () {
    this.$store.dispatch('contact/fetchUserContact')
  },
  HeaderRight
}
